import { createContext, useContext } from 'react';

import type { PaymentMethod as DepositMethod } from '#src/components/wallet/BankEthAccounting/AddFundsToFiatWallet/types.tsx';

interface DepositContextType {
  defaultDepositMethod?: DepositMethod;
  setDefaultDepositMethod: (mounted: DepositMethod) => void;
}

export const DepositContext = createContext<DepositContextType | null>(null);

export const useDepositContext = () => useContext(DepositContext)!;
